var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"is-fullheight",attrs:{"id":"app"}},[_c('Navbar',{attrs:{"logo":_vm.unitLogo}}),_c('Sidebar',{attrs:{"logo":_vm.unitLogo}}),_c('Footer'),_c('FlashMessage',{attrs:{"messages":_vm.flashMessages}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }